import {addDoc, collection, serverTimestamp} from "firebase/firestore";
import {db} from "../firebase-config.js";
import {Employer} from "../entities/Employer.js";

export class EmployerManager {
    static create(employer) {
        return addDoc(collection(db, Employer.collectionName), {...employer, createdAt: serverTimestamp()})
    }
}